import { formatDate } from 'utils/dateAndTime';
import { isUuid } from 'utils/object';
import { isRecord } from 'utils/typeChecks';

export const quoteCsvValue = (value: unknown) => `"${String(value ?? '').replaceAll('"', '""')}"`;

export const formatTableCsvValue = (value: unknown, isRecords = false) => {
  if (!Array.isArray(value)) return quoteCsvValue(value);

  if (isRecords) return quoteCsvValue(value.map((item) => (isRecord(item) ? (item.value ?? item.id ?? '') : item)).join(', '));

  if (value.some((item) => isUuid(item) || (isRecord(item) && Object.hasOwn(item, 'text')))) return quoteCsvValue(value.length);

  if (value.some((item) => isRecord(item) && Object.hasOwn(item, 'fullName'))) return quoteCsvValue(value.map((item) => item?.fullName).join(', '));

  if (value.some((item) => isRecord(item) && Object.hasOwn(item, 'value'))) return quoteCsvValue(value.map((item) => item?.value).join(', '));

  if (value.some((item) => (typeof item === 'string' || item instanceof Date) && !Number.isNaN(Date.parse(String(item)))))
    return quoteCsvValue(formatDate(new Date(value[0]), 'dd.MM.yyyy HH:mm'));

  if (value.some((item) => typeof item === 'number' && !Number.isNaN(item))) return quoteCsvValue(value.join(','));

  return quoteCsvValue(value.join(', '));
};
